import './reviews.scss';
import Swiper from 'swiper';
import { Scrollbar, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';
import { equalizeReviewTitles, debounce } from '@components/molecules/review/review.js';

document.addEventListener( 'DOMContentLoaded', function() {

	const sliders = document.querySelectorAll( '.js-reviewsSlider' );

	sliders.forEach( function( slider ) {
		const scrollbar = slider.querySelector( '.swiper-scrollbar' );
		const reviewsContainer = slider.closest( '.js-reviews' );
		const nextEl = slider.querySelector( '.o-reviews__arrow-next' );
		const prevEl = slider.querySelector( '.o-reviews__arrow-prev' );

		// Create debounced function for resize handling
		const debouncedEqualize = debounce( () => {
			equalizeReviewTitles( reviewsContainer );
		}, 100 );

		// Initialize Swiper
		const swiperInstance = new Swiper( slider, {
			modules: [ Scrollbar, Navigation ],
			slidesPerView: 1,
			spaceBetween: 32,
			grabCursor: true,
			scrollbar: {
				el: scrollbar,
				draggable: true,
				dragSize: 'auto',
			},
			navigation: nextEl && prevEl ? {
				nextEl: nextEl,
				prevEl: prevEl,
			} : false,
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
			on: {
				init: function() {
					// Equalize heights after Swiper initialization
					setTimeout( () => {
						equalizeReviewTitles( reviewsContainer );
					}, 50 );
				},
				resize: function() {
					// Equalize heights when Swiper resizes (breakpoint changes)
					setTimeout( () => {
						equalizeReviewTitles( reviewsContainer );
					}, 50 );
				},
			},
		} );

		// Add window resize listener for manual window resizing
		window.addEventListener( 'resize', debouncedEqualize );

		// Clean up event listener when the slider is destroyed
		// Note: This is a basic cleanup - in a more complex app you might want to track instances
		slider.addEventListener( 'swiper:destroy', () => {
			window.removeEventListener( 'resize', debouncedEqualize );
		} );
	} );

} );